onLoad(() => {
    // Do not load drift if the property is set
    if ('DO_NOT_LOAD_BIZIBLE' in window) {
        return;
    }
    var wistiaEmbedScript = document.createElement('script');
    wistiaEmbedScript.src = '//cdn.bizible.com/scripts/bizible.js';
    wistiaEmbedScript.async = true;
    document.body.appendChild(wistiaEmbedScript);
});
